module.exports = __webpack_public_path__ + "img/02.991c2e8f.png";